import lang from "@/views/modules/ApplicationBudgets/language/en";

let searchFieldsDef = {
    'name': {
        label: lang.LBL_BT_NAME,
    },
    'currency_multiplier': {
        label: lang.LBL_CR_MULTIPIER,
    },
    'application_title': {
        label: lang.LBL_PROJECT_NAME,
        relRef:'applicationbudgets_applications',
        
    },
    'opportunity_title': {
        label: lang.LBL_OPPORT_NAME,
        relRef:'applicationbudgets_opportunitys',
    },
    'app_budget_status': {
        label: lang.LBL_STAGE,
        type: 'select',
        field_infos: 'application_budget_filter',
    },
   /* 'strategic_priority': {
        label: lang.LBL_STRATEGIC_PRIORITY,
        type: 'checkbox',
        field_infos: 'strategic_priority',
    },*/
};
export default { searchFieldsDef }